import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useState } from 'react';
import { useTranslation } from '@stepstone-platform/i18n';
import { Input } from '../../../../components/common/Input/index.js';
import { PasswordToggle } from '../../../../components/common/PasswordToggle/PasswordToggle.js';
import { passwordSelector, updatePassword, updatePasswordError, updatePasswordErrorMessage, } from '../../registrationSlice.js';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux/index.js';
import { validatePassword } from '../../../../helpers/validatePassword.js';
export const RegistrationPasswordInput = () => {
    const { t } = useTranslation();
    const passwordState = useAppSelector(passwordSelector);
    const dispatch = useAppDispatch();
    const [toggleIcon, setToggleIcon] = useState(false);
    const passwordInputType = () => (toggleIcon ? 'text' : 'password');
    const onBlurPassword = ({ target: { value } }, isTouched) => {
        if (isTouched) {
            const passwordString = value;
            const hasError = !validatePassword(passwordString);
            dispatch(updatePasswordError(hasError));
            if (hasError) {
                dispatch(updatePasswordErrorMessage(t('loginregistration.password.validation.error')));
            }
        }
    };
    const passwordOnChange = ({ target: { value }, }) => {
        dispatch(updatePassword(value));
    };
    const { value, error, errorMessage } = passwordState;
    return (_jsx(Input, { dataTestId: "password-input", value: value, helpText: t('loginregistration.registration.password.helpText'), onChange: passwordOnChange, type: passwordInputType(), name: 'password', formLabel: t('loginregistration.registration.password.headerInput'), placeholder: t('loginregistration.registration.password.placeholder'), suffix: _jsx(PasswordToggle, { toggle: toggleIcon, onClick: () => setToggleIcon(!toggleIcon) }), hasError: error, errorText: errorMessage, onBlur: onBlurPassword, autoComplete: 'new-password' }));
};
//# sourceMappingURL=RegistrationPasswordInput.js.map